/* @flow */
import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import Glyph from 'components/Glyph';
import Image from 'components/Image';
import LayerTrigger from 'components/LayerTrigger';
import MediaObject from 'components/MediaObject';
import Menu from 'components/Menu';
import MenuItem from 'components/MenuItem';
import PDFDownload from 'components/PDFDownload';
import Row from 'components/Row';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';
import Group from 'entities/Group';
import Languages from 'lib/Languages';

import './UsersPdfInviteInstructions.scss';

const DEFAULT_PDF_LOCALE: string = 'en';
const PDF_LOCALES: Array<string> = ['en', 'es-419', 'es-ES', 'fr-FR', 'fr-CA', 'pt-BR'];

type Props = {
  group: Group,
};

type State = {
  locale: string,
};

export default class UsersPdfInviteInstructions extends React.Component<Props, State> {
  props: Props;

  state: State = {
    locale: DEFAULT_PDF_LOCALE,
  };

  setLocale = (locale: string): void => {
    this.setState({ locale });
  };

  render() {
    const { group } = this.props;
    const { locale } = this.state;

    const localesMenu = (
      <Menu selectedKey={locale}>
        {PDF_LOCALES.map(item => (
          <MenuItem
            onSelect={this.setLocale}
            key={item}
            eventElementName="Pdf-download-link"
            eventProperties={{
              foreign_id: group.id,
              foreign_table: 'groups',
              locale: item,
              screen_name: 'InvitePDFTab',
            }}>
            {Languages[item].name}
          </MenuItem>
        ))}
      </Menu>
    );

    const previewImage =
      group.getPdfUrl().includes('variant=new_pdf') && locale === DEFAULT_PDF_LOCALE
        ? require('assets/images/GroupInviteModal/new_mobile_join_pdf.png')
        : require('assets/images/GroupInviteModal/mobile_join_pdf.png');

    return (
      <Text align="center" className="UsersPdfInviteInstructions">
        <TitleHeader
          title={
            <React.Fragment>
              PDF instructions on how to join <Text weight="semibold">{group.getName()}</Text>
            </React.Fragment>
          }
        />
        <Row size="small">
          <Image
            src={previewImage}
            alt="Instructions PDF preview"
            className="UsersPdfInviteInstructions-img"
          />
        </Row>
        <Text color="graphite" element="div">
          Language:{' '}
          <LayerTrigger layer={localesMenu} alignment="middle" placement="top" trigger="click">
            <Button level="text">
              <MediaObject figure="right" gutter="xxsmall">
                <Text size="small">{Languages[locale].name}</Text>
                <Glyph name="chevron-down" size="xxsmall" solo />
              </MediaObject>
            </Button>
          </LayerTrigger>
        </Text>
        {/* TODO: inline when 2018.oct.web.new_direct_add resolved */}
        <PDFDownload group={group} level="primary" locale={locale} type="button">
          Download PDF
        </PDFDownload>
      </Text>
    );
  }
}
